/* eslint-disable react/jsx-props-no-spreading */
import {
  Avatar,
  Group,
  Text,
  UnstyledButton,
  UnstyledButtonProps,
} from "@mantine/core";
import { ChevronDownIcon } from "lucide-react";
import { useState } from 'react';

interface UserButtonProps extends UnstyledButtonProps {
  image?: string;
  name?: string;
  email?: string;
  icon?: React.ReactNode;
  minimized?: boolean;
}

const UserButton = ({
  image, name, email, icon, minimized = false, ...others
}: UserButtonProps) => {
  const [hovered, setHovered] = useState(false);

  return (
    <UnstyledButton
      style={{
        display: "block",
        padding: "5px",
        cursor: "pointer",
        transition: "background-color 150ms ease",
        backgroundColor: hovered ? "#f8f9fa" : "transparent",
      }}
      className={minimized ? "mx-auto" : ""}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...others}
    >
      <Group gap={5} justify="center">
        <Avatar size={20} variant="filled" src={image} color="black" radius="sm">
          {name?.charAt(0)}
        </Avatar>

        <div className={`${minimized && "hidden"} flex justify-between items-center`} style={{ flex: 1 }}>
          <Text size="sm" truncate fw={500} className="flex-1">
            {name}
          </Text>

        </div>

        {!minimized ? (icon || <ChevronDownIcon size="0.9rem" className="shrink-0" />) : ""}
      </Group>
    </UnstyledButton>
  );
};

export default UserButton;
